import React from "react";
import { motion } from "framer-motion";
import {
    Sparkles,
    Code2,
    Cpu,
    Cloud,
    Smartphone,
    Database,
    Brain,
    Bot,
    Layers,
    Workflow,
    Zap,
    ShieldCheck,
} from "lucide-react";

const items = [
    { icon: Code2, label: "React · Next.js" },
    { icon: Cpu, label: "FastAPI · Node" },
    { icon: Database, label: "MongoDB · Postgres" },
    { icon: Cloud, label: "AWS · GCP" },
    { icon: Brain, label: "OpenAI · Claude · Gemini" },
    { icon: Smartphone, label: "Flutter · React Native" },
    { icon: Bot, label: "WhatsApp Business API" },
    { icon: Workflow, label: "n8n · Zapier" },
    { icon: Layers, label: "Tailwind · shadcn" },
    { icon: Zap, label: "Redis · Kafka" },
    { icon: ShieldCheck, label: "Razorpay · Stripe" },
    { icon: Sparkles, label: "RAG · Vector DBs" },
];

const TrustMarquee = () => {
    const row = [...items, ...items];
    return (
        <section
            data-testid="trust-marquee"
            className="relative py-12 border-y border-white/5 bg-black/40"
        >
            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" />
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" />
            <p className="text-center font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-6">
                Built on a battle-tested modern stack
            </p>
            <div className="overflow-hidden">
                <motion.div
                    className="flex gap-12 items-center"
                    style={{ width: "max-content" }}
                    animate={{ x: ["0%", "-50%"] }}
                    transition={{
                        duration: 38,
                        repeat: Infinity,
                        ease: "linear",
                    }}
                >
                    {row.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <div
                                key={i}
                                className="flex items-center gap-3 text-zinc-400 hover:text-cyan-300 transition px-3"
                            >
                                <Icon className="h-5 w-5" strokeWidth={1.5} />
                                <span className="font-mono text-sm uppercase tracking-[0.18em]">
                                    {it.label}
                                </span>
                            </div>
                        );
                    })}
                </motion.div>
            </div>
        </section>
    );
};

export default TrustMarquee;
